import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Logo } from '@/components/shared/Logo'

export function RouteErrorPage() {
  const error = useRouteError()
  const navigate = useNavigate()

  const is404 = isRouteErrorResponse(error) && error.status === 404

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-6">
      <div className="mb-8">
        <Logo size={44} theme="light" />
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8 w-full max-w-md text-center">
        {is404 ? (
          <p className="text-5xl font-bold text-slate-200 mb-4">404</p>
        ) : (
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-50 mx-auto mb-4">
            <AlertTriangle size={22} className="text-red-500" />
          </div>
        )}

        <h1 className="text-lg font-semibold text-slate-900 mb-2">
          {is404 ? 'Page not found' : 'Something went wrong'}
        </h1>
        <p className="text-sm text-slate-500 mb-6 leading-relaxed">
          {is404
            ? "The page you're looking for doesn't exist or you may not have permission to view it."
            : 'An unexpected error occurred. Try refreshing the page or going back.'}
        </p>

        <div className="flex gap-3 justify-center">
          <Button variant="outline" onClick={() => navigate(-1)}>
            Go back
          </Button>
          <Button onClick={() => navigate('/')}>
            Go to home
          </Button>
        </div>
      </div>
    </div>
  )
}
